export interface ThemeColorScheme {
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  textColor: string;
  backgroundColor: string;
}

export const LAYOUT_COLOR_SCHEMES: Record<string, ThemeColorScheme> = {
  modern: {
    primaryColor: '#3B82F6',    // Blue
    secondaryColor: '#1E40AF',  // Dark Blue
    accentColor: '#F59E0B',     // Amber
    textColor: '#1F2937',       // Dark Gray
    backgroundColor: '#FFFFFF'   // White
  },
  elegant: {
    primaryColor: '#DC2626',    // Red
    secondaryColor: '#991B1B',  // Dark Red
    accentColor: '#F59E0B',     // Amber
    textColor: '#1F2937',       // Dark Gray
    backgroundColor: '#FEF2F2'  // Light Red
  },
  minimal: {
    primaryColor: '#374151',    // Gray
    secondaryColor: '#111827',  // Dark Gray
    accentColor: '#6B7280',     // Medium Gray
    textColor: '#1F2937',       // Dark Gray
    backgroundColor: '#FFFFFF'  // White
  },
  artistic: {
    primaryColor: '#8B5CF6',    // Purple
    secondaryColor: '#7C3AED',  // Dark Purple
    accentColor: '#EC4899',     // Pink
    textColor: '#1F2937',       // Dark Gray
    backgroundColor: '#F3F4F6'  // Light Gray
  },
  neon: {
    primaryColor: '#06B6D4',    // Cyan
    secondaryColor: '#0891B2',  // Dark Cyan
    accentColor: '#EC4899',     // Magenta
    textColor: '#FFFFFF',       // White
    backgroundColor: '#000000'  // Black
  },
  vintage: {
    primaryColor: '#D97706',    // Amber
    secondaryColor: '#B45309',  // Dark Amber
    accentColor: '#92400E',     // Brown
    textColor: '#1F2937',       // Dark Gray
    backgroundColor: '#FEF3C7'  // Light Amber
  },
  cosmic: {
    primaryColor: '#6366F1',    // Indigo
    secondaryColor: '#4F46E5',  // Dark Indigo
    accentColor: '#A855F7',     // Purple
    textColor: '#FFFFFF',       // White
    backgroundColor: '#0F172A'  // Dark Blue
  },
  serene: {
    primaryColor: '#10B981',    // Emerald
    secondaryColor: '#059669',  // Dark Emerald
    accentColor: '#06B6D4',     // Cyan
    textColor: '#1F2937',       // Dark Gray
    backgroundColor: '#F0FDF4'  // Light Green
  },
  bold: {
    primaryColor: '#F97316',    // Orange
    secondaryColor: '#EA580C',  // Dark Orange
    accentColor: '#EF4444',     // Red
    textColor: '#FFFFFF',       // White
    backgroundColor: '#1F2937'  // Dark Gray
  }
};

export const getThemeColors = (layout: string): ThemeColorScheme => {
  return LAYOUT_COLOR_SCHEMES[layout] || LAYOUT_COLOR_SCHEMES.modern;
};

export const getLayoutDisplayName = (layout: string): string => {
  const displayNames: Record<string, string> = {
    modern: 'Modern',
    elegant: 'Elegant',
    minimal: 'Minimal',
    artistic: 'Artistic',
    neon: 'Neon',
    vintage: 'Vintage',
    cosmic: 'Cosmic',
    serene: 'Serene',
    bold: 'Bold'
  };
  return displayNames[layout] || layout;
};

export const getLayoutDescription = (layout: string): string => {
  const descriptions: Record<string, string> = {
    modern: 'Clean, gradient-based design with cards',
    elegant: 'Sophisticated, full-width sections',
    minimal: 'Simple, content-focused design',
    artistic: 'Creative with geometric shapes and effects',
    neon: 'Cyberpunk-inspired with glowing effects',
    vintage: 'Retro design with classic typography',
    cosmic: 'Space-themed with deep gradients and stars',
    serene: 'Calming nature-inspired with soft colors',
    bold: 'High-contrast with vibrant, energetic colors'
  };
  return descriptions[layout] || '';
}; 